// @flow
import qs from 'qs';

export const sendMessageToParent = (message: Message): void => {
  window.parent.postMessage(message, window.location.origin);
  log('Message to parent', message);
};

export const waitForMessage = (name: string, callback: Function): void =>
  window.addEventListener('message', (event) => {
    if (event.origin !== window.location.origin) return;
    const { type, payload } = event.data;
    if (type !== name) return;
    callback(payload);
  });

// eslint-disable-next-line no-console
export const log = (...msg: any): void => dev() && console.log(...msg);

export const dev = () =>
  process.env.NODE_ENV === 'development' ||
  qs.parse(window.location.search, { ignoreQueryPrefix: true }).dev ||
  window.parent.dev ||
  window.dev;

export const loadGMaps = (): Promise<Function> =>
  new Promise((resolve) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }
    window.initMap = () => resolve(window.google.maps);
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?callback=initMap&key=${process.env.GOOGLE_MAPS_TOKEN}&language=de&libraries=places&region=de_DE`;
    script.async = true;
    if (document.head) {
      document.head.appendChild(script);
    }
  });

export const error = (msg: string): void => {
  if (!window.Rollbar) log(msg);
  window.Rollbar.error(msg);
};

export const warn = (message: string, err: ?Error, extra: ?Object): void => {
  if (window.Rollbar) {
    window.Rollbar.warn(message, err, extra);
  }
  log(message);
};

export const sendHeightParamToParent = (isFirstStep: boolean): void => {
  if (!document.body) {
    warn('Cant calculate height of iframe');
    return;
  }
  sendMessageToParent({
    type: 'IS_FIRST_STEP',
    payload: isFirstStep,
  });
};

export const isEmpty = (item: Object | String | Array<any>): boolean =>
  (typeof item === 'object' ? Object.keys(item) : item).length === 0;

export const getParams = (): ?Object => {
  const { search } = window.location;
  if (search.length === 0) return null;
  return qs.parse(search.substr(1));
};
